/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getConversationList: (params) => {
    return axios.get(API_ENDPOINTS.GET_CONVERSATIONS_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  getConversationById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_CONVERSATIONS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteConversation: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_CONVERSATIONS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
